module.exports = {
	"articleTitle1": "Best Mediterranean: Jerusalem Garden ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Jerusalem Garden",
	"articleLink1": "https://www.michigandaily.com/section/arts/best-ann-arbor-jerusalem-garder",
	"articleLink2": "https://www.michigandaily.com/content/best-ann-arbor-jerusalem-garden",
	"articleSnippet1": "Apr 2, 2017 ... Really, the best compliment I can bestow is that Jerusalem Garden would be, \nhands down, the ideal place for a date.",
	"articleSnippet2": "Apr 9, 2008 ... Located in a yellow-painted, box-shaped building on Fifth Street between Liberty \nand William, Jerusalem Garden is unlike any Middle Eastern ...",
	"foodRecommendations": [
		{
			"text": "It's cheap and good and healthy and fast",
			"person": "Marisa Iaderosa"
		}
	],
	"articleTitle2": "The Best of Ann Arbor: Jerusalem Garden",
	"address": "314 E Liberty St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170405/msk.NEW_.JeruselamGarden.4.1.17.0011.jpg?itok=gShb8xPO",
			"author": "Max Kuang",
			"caption": " "
		}
	],
	"position": {
		"lat": 42.279212,
		"lng": -83.74541
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/jerusalemgarden.json
// module id = 899
// module chunks = 0